export const yesNoOptions = [
  { value: "", label: "Default", arabic_label: "افتراضي" },
  { value: "Yes", label: "Yes", arabic_label: "نعم" },
  { value: "NO", label: "No", arabic_label: "لا" },
];

export const clientOptions = [
  { value: "", label: "Default", arabic_label: "افتراضي" },
  { value: "NO", label: "No", arabic_label: "لا" },
  { value: "YES", label: "Yes", arabic_label: "نعم" },
  { value: "UNDEFINED", label: "Undefined", arabic_label: "غير محدد" },
  { value: "FREE", label: "Free", arabic_label: "مجاني" },
];

export const serviceRequiredOptions = [
  { value: "", label: "Default", arabic_label: "افتراضي" },
  { value: "ONLINE", label: "Online", arabic_label: "عبر الإنترنت" },
  { value: "EMPLOYMENT", label: "Employment", arabic_label: "توظيف" },
  {
    value: "HR_ASSISTANCE",
    label: "HR Assistance",
    arabic_label: "مساعدة الموارد البشرية",
  },
];

export const ourContactOptions = [
  { value: "", label: "Default", arabic_label: "افتراضي" },
  { value: "HR", label: "HR", arabic_label: "الموارد البشرية" },
  { value: "NO", label: "No", arabic_label: "لا" },
];

export const cultureOptions = [
  { value: "", label: "Default", arabic_label: "افتراضي" },
  { value: "PROFESSIONAL", label: "Professional", arabic_label: "محترف" },
  {
    value: "NOT_PROFESSIONAL",
    label: "Not Professional",
    arabic_label: "غير محترف",
  },
  { value: "MEDIUM", label: "Medium", arabic_label: "متوسط" },
];

export const lastSignInOptions = [
  { value: "", label: "Default", arabic_label: "افتراضي" },
  { value: "today", label: "Today", arabic_label: "اليوم" },
  { value: "week", label: "Week", arabic_label: "اسبوع" },
  { value: "month", label: "Month", arabic_label: "شهر واحد" },
  { value: "6month", label: "6 Months", arabic_label: "ستة أشهر" },
  { value: "year", label: "12 Months", arabic_label: "اثنا عشر شهرًا" },
];

export const postedVacsOptions = [
  { value: "", label: "Default", arabic_label: "افتراضي" },
  { value: "0", label: "0", arabic_label: "٠" },
  { value: "1", label: "1", arabic_label: "١" },
  { value: "2", label: "2", arabic_label: "٢" },
  { value: "3", label: "3", arabic_label: "٣" },
  { value: "4-7", label: "4-7", arabic_label: "٤-٧" },
  { value: "8-12", label: "8-12", arabic_label: "٨-١٢" },
  { value: "12", label: "More than 12", arabic_label: "أكثر من ١٢" },
];
